import { render, staticRenderFns } from "./AvailableLocationsOtherRegion.vue?vue&type=template&id=905ef884"
import script from "./AvailableLocationsOtherRegion.vue?vue&type=script&lang=js"
export * from "./AvailableLocationsOtherRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports